/*====================================================
	References Slider
====================================================*/
const selector_references = 'js__slider-references';

const elements_references = document.querySelectorAll(
	`.${selector_references}`
);

if (elements_references !== null) {
	for (const element of elements_references) {
		buildSwiperReferences(element);
	}
}

function buildSwiperReferences(swiperElement) {
	const sliderIdentifier = swiperElement.dataset.swiperId;
	return new Swiper(`#swiper-${sliderIdentifier}`, {
		slidesPerView: 1.1,
		spaceBetween: 15,
		loop: false,
		breakpoints: {
			450: {
				slidesPerView: 1.4,
			},
			550: {
				slidesPerView: 1.8,
			},
			768: {
				slidesPerView: 2.2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
	});
}